import React, { useContext } from 'react'
import '../scss/components/section.scss'
import Header from '../components/header/header.jsx'
import Banner from '../components/banner/banner-v3'
import dataFooter from '../assets/fake-data/data-footer'
import Bottom from '../components/bottom'
import Footer from '../components/footer/footer-v2'
import AccountAccessPanel from '../components/signin-panel/index.jsx'
import { Context } from '../contexts/GlobalContext.js'
import { useNavigate } from 'react-router-dom'
import { Pricing } from './Pricing/Pricing.jsx'

const Login = () => {
  const navigate = useNavigate()

  const { globalState } = useContext(Context)
  if (globalState?.user?._id) {
    navigate('/nelima')
  }
  return (
    <div className='wrapper-style' id='wrapper'>
      <AccountAccessPanel panelMode='login' isCloseDisabled={true}/>
      <Header />
      <Banner/>
      <div className='front-sndbx-wrapper'></div>
      <Pricing type='component' theme='dark'/>
      <Footer data={dataFooter}/>
      <Bottom classection='widget-social-footer home2'/>
    </div>
  )
}

export default Login